import { Badge } from '@/components/ui/badge';
import type { IInvoiceStatusBadgeProps } from '@/@types/invoice';

const statusConfig: Record<string, { label: string; className: string }> = {
  draft: {
    label: 'Draft',
    className: '!border-0 !bg-gray-100 !text-gray-800 dark:!bg-gray-900/30 dark:!text-gray-400',
  },
  sent: {
    label: 'Sent',
    className: '!border-0 !bg-blue-100 !text-blue-800 dark:!bg-blue-900/30 dark:!text-blue-400',
  },
  paid: {
    label: 'Paid',
    className: '!border-0 !bg-green-100 !text-green-800 dark:!bg-green-900/30 dark:!text-green-400',
  },
  partially_paid: {
    label: 'Partially Paid',
    className:
      '!border-0 !bg-yellow-100 !text-yellow-800 dark:!bg-yellow-900/30 dark:!text-yellow-400',
  },
  overdue: {
    label: 'Overdue',
    className: '!border-0 !bg-red-100 !text-red-800 dark:!bg-red-900/30 dark:!text-red-400',
  },
  cancelled: {
    label: 'Cancelled',
    className: '!border-0 !bg-gray-100 !text-gray-800 dark:!bg-gray-900/30 dark:!text-gray-400',
  },
};

export function InvoiceStatusBadge({ status }: IInvoiceStatusBadgeProps) {
  const config = statusConfig[status] ?? statusConfig['draft'];
  return (
    <Badge className={config.className} variant="outline">
      {config.label}
    </Badge>
  );
}
